import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';


@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.less']
})
export class BreadcrumbsComponent implements OnInit {

  details: any;
  entityId: any;

  constructor(private _router: Router, private activatedRoute: ActivatedRoute) { }
  breadcrumbItems: {};

  ngOnInit() {
    this.activatedRoute.params.subscribe(() => {
      if (this.activatedRoute.snapshot.data.details !== undefined) {
        this.entityId = this.activatedRoute.snapshot.params.id;
        this.details = this.activatedRoute.snapshot.data.details.response;
      }
      this.breadcrumbItems = this.createBreadcrumbs(this._router.url);
    });
  }

  createBreadcrumbs(urls): Array<[]> {
    let splitedUrls = urls.split('/');
    let menuItems = [];

    let path = '';
    for (let index = 0; index < splitedUrls.length; index++) {
      let name = splitedUrls[index];
      let specialPath;
      if (splitedUrls[index].indexOf('?') > -1 ) {
        name = splitedUrls[index].substring(0, splitedUrls[index].indexOf('?'));
      }

      if (name === this.entityId) { name = this.details.name; }

      path += splitedUrls[index] + '/';

      // Workaround for history page
      path = path.replace('results', 'history');
      if ( index === 1 && path.split('/')[1] === 'history') {
        specialPath = path + 'testcase/';
        console.log(path);
      }

      if (index > 0) {
        if (name === 'endpoint') {
          menuItems.push({
            'name': name,
            'url': path,
            'queryParams': { 'page': 1, 'size': 15 }
          });
        } else {
          menuItems.push({
            'name': name,
            'url': specialPath || path
          });
        }
      }
    }
    return menuItems;
  }


}
